import { put, takeEvery, takeLatest} from 'redux-saga/effects';
import axios from 'axios';

function* fetchCurrentContest(action) {
    try {
        let currentContestResponse = yield axios.get('/currentContest', action.payload)
        console.log('current contest saga response!', currentContestResponse);
        yield put({
            type: 'SET_CURRENT_CONTEST',
            payload: currentContestResponse.data[0]
        })
    } catch (err) {
        console.log('error in CURRENT CONTEST GET', err);
    }
}

function* updateCurrentContest(action) {
    try {
        let updateCurrentContestResponse = yield axios.put('/currentContest', action.payload)
        console.log('update current contest saga response!', updateCurrentContestResponse);
        yield put({
            type: 'FETCH_CURRENT_CONTEST'
        })
    } catch (err) {
        console.log('error in CURRENT CONTEST PUT', err);
    }
}

function* updateCurrentContestDetails(action) {
    try {
        let updateCurrentContestDetailsResponse = yield axios.put ('/currentContest/details', action.payload)
        console.log('update current contest details saga response!', updateCurrentContestDetailsResponse);
        yield put({
            type: 'FETCH_CURRENT_CONTEST'
        })
    } catch (err) {
        console.log('error in CURRENT CONTEST DETAILS PUT', err);
    }
}

function* addSpeedRound(action) {
    try {
        let addSpeedRoundResponse = yield axios.post('/currentContest/addSpeedRound', action.payload)
        console.log('add speed round saga response!', addSpeedRoundResponse);
        yield put({
            type: 'FETCH_SPEED_ROUND',
            payload: action.payload.contestHour
        })
    } catch (err) {
        console.log('error in ADD SPEED ROUND POST', err);
    }
}

function* fetchSpeedRound(action) {
    try {
        let currentHour = action.payload;
        console.log('the current hour after the speed round add is', currentHour)
        let fetchSpeedRoundResponse = yield axios.get(`/currentContest/fetchSpeedRound/${currentHour}`)
        console.log('speed round saga response!', fetchSpeedRoundResponse.data[0]);
        yield put({
            type: 'SET_SPEED_ROUND',
            payload: fetchSpeedRoundResponse.data[0]
        })
    } catch (err) {
        console.log('error in SPEED ROUND GET', err);
    }
}

function* deleteSpeedRound(action) {
    try {
        const currentContest = action.payload.currentContest;
        const contestHour = action.payload.contestHour;
        const queryToDelete = 'currentContest=' + currentContest + '&' + 'contestHour=' + contestHour;
        let deleteSpeedRoundResponse = yield axios.delete(`/currentContest/deleteSpeedRound/${queryToDelete}`)
        console.log('delete speed round saga response!', deleteSpeedRoundResponse.data);
        yield put({
            type: 'SET_SPEED_ROUND',
            payload: contestHour
        })
    } catch (err) {
        console.log('error in SPEED ROUND DELETE', err);
    }
}

function* currentContestSaga() {
    yield takeEvery('FETCH_CURRENT_CONTEST', fetchCurrentContest);
    yield takeEvery('UPDATE_CURRENT_CONTEST', updateCurrentContest);
    yield takeLatest('UPDATE_CURRENT_CONTEST_DETAILS', updateCurrentContestDetails);
    yield takeEvery('ADD_SPEED_ROUND', addSpeedRound);
    yield takeEvery('FETCH_SPEED_ROUND', fetchSpeedRound);
    yield takeEvery('DELETE_SPEED_ROUND', deleteSpeedRound);
}

export default currentContestSaga;